import { render, staticRenderFns } from "./TestingsList.vue?vue&type=template&id=009fae02"
import script from "./TestingsList.vue?vue&type=script&lang=ts"
export * from "./TestingsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports